class NewsletterToggle {
  constructor($main, config) {
    this.defaultConfig = {
      showClass: 'newsletter-toggle--is-open',
    }
    this.config = Object.assign({}, this.defaultConfig, config);
    this.initDomElements($main);
    this.initToggle();
  }

  initDomElements($main) {
    this.domElements = {};
    this.domElements.main = $main;
    if (this.domElements.main.length < 1) return false;

    this.domElements.button = this.domElements.main.find('.newsletter-toggle__button');
    this.domElements.content = this.domElements.main.find('.newsletter-toggle__content');
    return true;
  }

  initToggle() {
    this.domElements.button.on('click', () => {
      if (this.domElements.main.hasClass(this.config.showClass)) {
        this.hideContent();
      } else {
        this.showContent();
      }
    });
  }

  showContent() {
    this.domElements.main.addClass(this.config.showClass);
    this.domElements.button.attr('aria-expanded', 'true');
  }

  hideContent() {
    this.domElements.main.removeClass(this.config.showClass);
    this.domElements.button.attr('aria-expanded', 'false');
  }

}

export default NewsletterToggle;
